import React from 'react';
import Choice from "./choice/ChoiceContainer";

const Choices = props => {
  const letters = ['A', 'B', 'C', 'D'];

  return letters.map(letter => <Choice key={letter} letter={letter}/>);
};

export default Choices;
